import { Tab } from '../../core/services/interface';
import { ModalModule } from "ngx-bootstrap/modal";
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { TabNames, c1, c16, common_components_map } from "src/app/core/services/constants";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { BuilderService } from 'src/app/sharedservices/builder.service';

@Component({
  selector: "app-mobile-view-tab",
  templateUrl: "./mobile-view-tab.component.html",
  styleUrls: ["./mobile-view-tab.component.scss"],
})
export class MobileViewTabComponent implements OnInit, OnDestroy {
  updateBuilderComponentSubscription: any;
  colorsComponentSubscription: any;
  tabNames = TabNames;
  mode;
  mobileViewModeMap;
  inputData;
  image: string;
  tab_bgimage: string;
  start_color: string;
  end_color: string;
  bg_color: string;
  latestRequestRef: string;
  bgObject: any;
 isLight: boolean;
surfaceColor : string;
  colors: any = {};
  color_schema: any;
  color_schema_ios: any;
  light: {};
  dark: {};
  isAndroid: string;
  inputMenuId: string;

  @Input() inputTab: any;
  @Input() fontSmaller: boolean;
  @Input() enableStatic: boolean =false;
  @Input() enableForChat: boolean =false;
  @Input() inputMenu: any;
  fontResize= true;

  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    public ref: ChangeDetectorRef,
    private builderService: BuilderService,

  ) {}

  ngOnInit() {
  this.image = "./assets/images/mobile-view-builder-item-empty-s.webp";
  this.light = localStorage.getItem("mode")[15] == c16.LIGHT ? true : false;
  this.mobileViewModeMap = common_components_map;
   this.colorInitialize();



  this.colorsComponentSubscription = this.mdw.colorsComponentContainer$.subscribe(async (data) => {
    if (data && data.color_schema  && data.color_schema_ios && data.light !=null) {
      this.colors = data;
      this.light = data.light
      this.color_schema = this.light? this.colors.color_schema.schemes.light:this.colors.color_schema.schemes.dark ;
      this.color_schema_ios = this.light? this.colors.color_schema_ios.schemes.light:  this.colors.color_schema_ios.schemes.dark
      this.isLight = this.colors["light"];
      try {
        await this.colorInitialize()
        this.initialize();
      } catch (error) {

      }

    }
  })

   this.updateBuilderComponentSubscription =
      this.mdw.updateBuilderComponentContainer$.subscribe(async (data) => {
        if (data) {
          if (this.inputTab){
            this.inputData = this.inputTab;
          }else if (this.inputMenu){
          } else
          {
            this.inputData = data.tab;

          }
               this.image = "./assets/images/mobile-view-builder-item-empty-s.webp";
               await this.colorInitialize()
               this.initialize()
        }
      });
  }

  initialize(){
    this.isAndroid = localStorage.getItem("mode")[0];
            if (this.isAndroid === c1.ANDROID && this.color_schema) {
              this.bg_color = this.color_schema.m2CSurface;
            } else if (this.isAndroid === c1.IOS && this.color_schema_ios) {
              this.bg_color = this.color_schema_ios.surface;
            }

            this.inputMenuId =   this.inputMenu? this.inputMenu.menu_id: null

            this.bgInitialize(this.inputMenuId, this.inputTab)


            if (this.colors && this.colors.color_schema && this.colors.color_schema.schemes){
              this.surfaceColor = this.isAndroid ? this.builderService.buttonColor(null, this.colors.color_schema, null, 'surface', this.light):this.builderService.buttonColor(null, this.colors.color_schema_ios, null, 'surface', this.light)
            }
          }


async colorInitialize() {
  try {
    const appHome = this.indexDBService.getItem("app", 'home');
    appHome.onsuccess = async (event) => {
      if (appHome.result) {
        this.colors['color_schema'] = appHome.result.app.tabs.color_schema;
        this.colors['color_schema_ios'] = appHome.result.app.tabs.color_schema_ios;
        this.colors['light'] = localStorage.getItem("mode")[15]==c16.LIGHT? true:false
        this.isLight = this.colors['light']

      } }
  } catch (error) {

  }
   }



async bgInitialize(menuId, inputTab) {
  const requestRef = this.mdw.makeRef(16);

  this.latestRequestRef = requestRef;

  this.bgObject = null;

  const getMenuById = async (menuId) => {
    return new Promise((resolve) => {
      const menuRequest = this.indexDBService.getItem("menu", menuId);
      menuRequest.onsuccess = () => resolve(menuRequest.result);
      menuRequest.onerror = () => resolve(null);
    });
  };

  const getTabById = async (tabId) => {
    return new Promise((resolve) => {
      const tabRequest = this.indexDBService.getItem("tab", tabId);
      tabRequest.onsuccess = () => resolve(tabRequest.result);
      tabRequest.onerror = () => resolve(null);
    });
  };

  const processMenu = async (menu) => {
    if (menu && menu.menu_bg) {
      this.menuBackground(menu.menu_bg);
      return true;
    }
    if (menu && menu.menu_group) {
      let tab: any;
       tab = await getTabById(menu.menu_group);
      if (this.latestRequestRef !== requestRef) return true;
      if (tab && tab.tab_bg) {
        this.menuBackground(tab.tab_bg);
        return true;
      }
    }
    return false;
  };

  let menu = menuId ? await getMenuById(menuId) : null;
  if (this.latestRequestRef !== requestRef) return;

  if (await processMenu(menu)) return;

  if ((!menuId || menuId === null || menuId === undefined) && inputTab && inputTab.menu_id) {
    menu = await getMenuById(inputTab.menu_id);
    if (this.latestRequestRef !== requestRef) return;
    if (await processMenu(menu)) return;
  }

  if (inputTab && inputTab.tab_bg) {
    this.menuBackground(inputTab.tab_bg);
    return;
  }

  if (this.latestRequestRef !== requestRef) return;

  this.menuBackground(null);
}
menuBackground(bgObject) {
  let image: string =null
  let start: string = null;
  let end: string = null;

  if (bgObject){
    let image_light = (bgObject && bgObject.image)? bgObject.image:null
    let image_dark = (bgObject && bgObject.image_dark)? bgObject.image_dark :null
    image = this.isLight? image_light: image_dark? image_dark:image_light
    start = this.isLight? bgObject.start: bgObject.start_dark;
    end = this.isLight? bgObject.end: bgObject.end_dark;
  }

    if (bgObject && image) {
    this.tab_bgimage = image;
    this.start_color = null;
    this.end_color = null;
    this.bg_color = null;
  } else if (bgObject && (start || end)) {
    this.tab_bgimage = null;
    this.start_color = start || null;
    this.end_color = end || null;
    this.bg_color = (!this.end_color) ? this.start_color : (!this.start_color ? this.end_color : null);
  } else {
    this.tab_bgimage = null;
    this.start_color = null;
    this.end_color = null;
    this.bg_color = null;
  }
}

get setTabBg() {
  if (this.tab_bgimage) {
    return {
      "background-image": `url(${this.tab_bgimage})`,
      "background-position": "center",
      "background-repeat": "no-repeat",
      "background-size": "cover",
    };
  } else if (this.start_color && this.end_color) {
    return {
      "background-image": `linear-gradient(180deg, ${this.start_color}, ${this.end_color})`,
    };
  } else if (this.bg_color) {
    return { background: this.bg_color };
  }
  return { "background": this.surfaceColor }
}


  ngOnDestroy(): void {
    // console.log("destroy");
    if (this.updateBuilderComponentSubscription) {
      this.updateBuilderComponentSubscription.unsubscribe();
    }

    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
  }
}
